import { useToggle } from "utils/Hooks"
import { FleContinueWrapper, FleLayout } from "components/views/fle/FleLayout"
import { TopSection } from "components/views/fle/TopSection"
import { LeftArrow, ContinueArrow, SwitchH2ToBodyLarge } from "components/views/fle/Molecules"
import { Spacer } from "components/views/atoms/Atoms"
import { Checkbox } from "components/views/atoms/Checkbox"
import { Body } from "components/views/atoms/Bodies"
import { TextLink } from "components/views/atoms/links/TextLink"
import FLEInformationModal from "components/views/modal/FLEInformationModal"
import React from "react"
import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

export const AcknowledgeTerms = ({
  readPolicy,
  setReadPolicy,
  readTerms,
  firstName,
  preferredName,
  setReadTerms,
  onBack,
  onComplete,
  benefitConfiguration
}) => {
  const [showTermsAndConditionsModal, toggleTermsAndConditionsModal] = useToggle(false)
  const [showPrivacyPolicyModal, togglePrivacyPolicyModal] = useToggle(false)

  return (
    <FleLayout
      bottomContent={
        <FleContinueWrapper>
          <ContinueArrow onClick={onComplete} enabled={readTerms && readPolicy} />
        </FleContinueWrapper>
      }
    >
      <TopSection showProgressTracker={false} progressStep={1} leftOrBackArrow={<LeftArrow onClick={onBack} />} />
      <SwitchH2ToBodyLarge>
        Thanks, {preferredName || firstName}.
        <Spacer height={1} />
        Before we continue, we want to make sure that you’re aware of our terms and how we’ll use your personal info.
      </SwitchH2ToBodyLarge>
      <Spacer height={2} />
      <label>
        <div className="flex flex-row">
          <Checkbox checked={readTerms} onChange={(e) => setReadTerms(e.target.checked)} />
          <div className="ml2">
            <Body>
              I have read and accept the&nbsp;
              <TextLink underlineColor="black-80" onClick={toggleTermsAndConditionsModal}>
                {l`fle2.termsAndConditions`}
              </TextLink>
              .
            </Body>
          </div>
        </div>
      </label>
      <Spacer height={1} />
      <label>
        <div className="flex flex-row">
          <Checkbox checked={readPolicy} onChange={(e) => setReadPolicy(e.target.checked)} />
          <div className="ml2">
            <Body>
              I have read and accept the&nbsp;
              <TextLink underlineColor="black-80" onClick={togglePrivacyPolicyModal}>
                {l`fle2.privacyPolicy`}
              </TextLink>
              {l` and agree to the processing of sensitive personal data.`}
            </Body>
          </div>
        </div>
      </label>
      {showPrivacyPolicyModal ? (
        <FLEInformationModal
          onClose={togglePrivacyPolicyModal}
          header={l`fle2.privacyPolicy`}
          source={l`fle2.privacyPolicyFull`}
          benefitConfiguration={benefitConfiguration}
          showInDesktopView
          isTCPPModal
        />
      ) : null}
      {showTermsAndConditionsModal ? (
        <FLEInformationModal
          onClose={toggleTermsAndConditionsModal}
          header={l`fle2.termsAndConditions`}
          source={l`fle2.termsAndConditionsFull`}
          benefitConfiguration={benefitConfiguration}
          showInDesktopView
          isTCPPModal
        />
      ) : null}
    </FleLayout>
  )
}
